import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./app/store";
import { Toaster } from "react-hot-toast";
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

root.render(
  <GoogleOAuthProvider clientId={googleClientId}>
    <BrowserRouter>
      <Provider store={store}>
        <Toaster containerStyle={{ zIndex: 9999999 }} />
        <App />
      </Provider>
    </BrowserRouter>
  </GoogleOAuthProvider>
);
